import { findTabbableDescendants } from "./tabbable";

const focusLaterElements = [];
let focusElement = null;
let needToFocus = false;

const handleBlur = () => {
  needToFocus = true;
};

const handleFocus = () => {
  if (needToFocus) {
    needToFocus = false;
    if (!focusElement) {
      return;
    }
    if (!focusElement) return;
    if (focusElement.contains(document.activeElement)) {
      return;
    }
    const el = findTabbableDescendants(focusElement)[0] || focusElement;
    el.focus();
  }
};

export const markForFocusLater = () => {
  focusLaterElements.push(document.activeElement);
};

export const returnFocus = () => {
  let toFocus = null;
  try {
    toFocus = focusLaterElements.pop();
    if (toFocus) toFocus.focus();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(
      [
        "You tried to return focus to",
        toFocus,
        "but it is not in the DOM anymore",
      ].join(" ")
    );
  }
};

export const setupScopedFocus = (element) => {
  focusElement = element;
  document.addEventListener("focusout", handleBlur, false);
  document.addEventListener("focusin", handleFocus, true);
};

export const teardownScopedFocus = () => {
  focusElement = null;
  document.removeEventListener("focusout", handleBlur);
  document.removeEventListener("focusin", handleFocus);
};
